//import "babel-polyfill"; /* polyfill for some ES2015 features for older Browsers eg. Promises on IE11 */
import 'popper.js';
import 'bootstrap';
if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};
window.app.modules =  app.modules || {};

import initModulesInScope from "./libs/@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('./libs/@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

/*import * as ajaxInclude from './scripts/ajaxInclude';
app.modules.ajaxInclude = ajaxInclude.initInScope;*/

import * as goToLink from './libs/@elements/go-to-link';
app.goToLink = goToLink.init;

import * as actionChanger from './libs/@elements/action-changer';
app.modules.actionChanger = actionChanger.initInScope;

import * as toc from './libs/@elements/toc';
app.toc = toc.init;
app.modules.toc = toc.initInScope;

import * as floatingLabel from './libs/@elements/floating-labels';
app.modules.floatingLabel = floatingLabel.initInScope;

import * as expandable from './scripts/expandable';
app.modules.expandable = expandable.initInScope;

import * as baseScripts from './scripts/baseScripts';
app.modules.baseScripts = baseScripts.initInScope;

import * as lazyImg from './libs/@elements/lazy-img';
app.modules.lazyImg = lazyImg.initInScope;

import * as linkWithInputVal from './scripts/linkWithInputVal';
app.modules.linkWithInputVal = linkWithInputVal.initInScope;

import * as registerLink from './scripts/registerLink';
app.modules.registerLink = registerLink.initInScope;

import * as shariff from './scripts/shariff';
app.modules.shariff = shariff.initInScope;

import * as videoJS from './scripts/videoJS';
app.modules.videoJS = videoJS.initInScope;

import * as slider from './scripts/slider';
app.modules.slider = slider.initInScope;

import * as gallerySlider from './scripts/gallery-slider';
app.modules.gallerySlider = gallerySlider.initInScope;

import * as detailGallery from './scripts/detail-gallery';
app.modules.detailGallery = detailGallery.initInScope;

import * as parsley from './scripts/parsley';
app.modules.parsley = parsley.initInScope;

import * as lightbox from './scripts/lightbox';
app.modules.lightbox = lightbox.initInScope;

import * as touchNav from './scripts/touchNav';
app.modules.touchNav = touchNav.initInScope;

import * as rangeSlider from './scripts/rangeSlider';
app.modules.rangeSlider= rangeSlider.initInScope;

import * as map from './scripts/map';
app.modules.map = map.initInScope;

import * as mapbox from './scripts/mapbox';
app.modules.mapbox = mapbox.initInScope;

import * as stickyBox from './scripts/stickyBox';
app.modules.stickyBox = stickyBox.initInScope;

import * as smoothscroll from './scripts/smooth-scroll';
app.modules.smoothscroll = smoothscroll.initInScope;

import * as disableBtnAfterSubmit from './scripts/disableBtnAfterSubmit';
app.modules.disableBtnAfterSubmit = disableBtnAfterSubmit.initInScope;

import * as ajaxPrices from './scripts/ajaxPrices';
app.modules.ajaxPrices = ajaxPrices.initInScope;

import * as numberSpinner from './scripts/numberSpinner';
app.modules.numberSpinner = numberSpinner.initInScope;

import * as datepicker from './libs/@elements/datepicker';
app.modules.datepicker = datepicker.initInScope;

import * as datepickerRange from './scripts/datepicker-range';
app.modules.datepickerRange = datepickerRange.initInScope;

// import * as flatpickr from './scripts/flatpickr';
// app.modules.flatpickr = flatpickr.initInScope;

import * as easyPick from './scripts/easy-pick';
app.modules.easyPick = easyPick.initInScope;

import * as easyPickBlocked from './scripts/easy-pick-blocked';
app.modules.easyPickBlocked = easyPickBlocked.initInScope;

import * as portalSearch from './scripts/portal-search-bar';
app.modules.portalSearch = portalSearch.initInScope;

import * as portalSearchOld from './scripts/portal-search-bar-old';
app.modules.portalSearchOld = portalSearchOld.initInScope;

import * as detailSearch from './scripts/detail-search-bar';
app.modules.detailSearch = detailSearch.initInScope;

import * as detailSearchOld from './scripts/detail-search-bar-old';
app.modules.detailSearchOld = detailSearchOld.initInScope;

import * as messageModal from './scripts/messageModal';
app.modules.messageModal = messageModal.initInScope;

import * as collapsingRadio from './scripts/collapsingRadio';
app.modules.collapsingRadio = collapsingRadio.initInScope;

import * as collapsingPersons from './scripts/collapsingPersons';
app.modules.collapsingPersons = collapsingPersons.initInScope;

import * as collapsingCheckbox from './scripts/collapsingCheckbox';
app.modules.collapsingCheckbox = collapsingCheckbox.initInScope;

import * as checkChatSubmit from './scripts/checkChatSubmit';
app.modules.checkChatSubmit = checkChatSubmit.initInScope;

import * as objektDetailForm from './scripts/objektDetailForm';
app.modules.objektDetailForm = objektDetailForm.initInScope;

import * as accoDetail from './scripts/accoDetail';
app.modules.accoDetail = accoDetail.initInScope;

import * as loginModal from './scripts/login';
app.modules.loginModal = loginModal.initInScope;

import * as initReservation from './scripts/initReservation';
app.modules.initReservation = initReservation.initInScope;

import * as ajaxForm from './libs/@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.initInScope;

app.filterForm = function () {
    import('./scripts/filter-form/filter-form').then(function (filterForm) {
        app.modules.filterForm = filterForm.initInScope;

        filterForm.init();
        filterForm.initInScope($('body'));
    });

    import('./scripts/filter-form/quick-filter').then(function (quickFilter) {
        app.modules.filterFormquickFilter = quickFilter.initInScope;
        quickFilter.initInScope($('body'));
    });
};

app.filterFormMap = function () {
    import('./scripts/filter-form/filter-form-map').then(function (filterFormMap) {
        app.modules.filterFormMap = filterFormMap.initInScope;

        filterFormMap.initInScope($('body'));
    });
};


import * as watchList from './scripts/watchList';
app.modules.watchList = watchList.initInScope;
app.modules.getWatchListInfo = watchList.getWatchListInfo;

import * as productGrid from './libs/@elements/product-grid';
app.productGrid = productGrid.init;
app.modules.productGrid = productGrid.initInScope;

import { showCookieBar } from "./libs/@elements/cookie-permissions";
showCookieBar();

import * as cookieModalHelpers from './scripts/cookieModalHelpers';
app.modules.cookieModalHelpers = cookieModalHelpers.initInScope;

import * as placesAutocomplete from './scripts/placesAutocomplete';
app.modules.placesAutocomplete = placesAutocomplete.initInScope;

import * as hashRouter from './scripts/hashRouter';
app.modules.hashRouter = hashRouter.initInScope;

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})(jQuery);